export default __webpack_public_path__ + "static/media/facebook.e4a34c01.svg";